export const TOKEN_KEY = import.meta.env?.VITE_TOKEN_KEY ?? 'auth_token';
export const REFRESH_TOKEN_KEY = import.meta.env?.VITE_REFRESH_TOKEN_KEY ?? 'refresh_token';
export const API_BASE_URL = import.meta.env?.VITE_API_BASE_URL ?? 'http://localhost:3000/api';

// Host that firm subdomains live under, e.g. 'staging-customer-portal.benchmarkit.solutions'.
// Rendered read-only beside the subdomain input so users can see the address they are creating.
// Display only — the API is never sent the suffix, just the bare subdomain. Empty string is a
// valid value: the UI then shows no suffix rather than a dangling dot.
export const SUBDOMAIN_BASE_DOMAIN = import.meta.env?.VITE_BASE_DOMAIN ?? '';

// Public sales site the post-logout countdown forwards to (see LogoutPage).
export const SALES_SITE_URL = import.meta.env?.VITE_SALES_SITE_URL ?? 'https://leimberg.com';

// Keycloak Configuration
export const KEYCLOAK_URL = import.meta.env?.VITE_KEYCLOAK_URL ?? 'http://localhost:8180/auth';
export const KEYCLOAK_REALM = import.meta.env?.VITE_KEYCLOAK_REALM ?? 'Leimberg';
export const KEYCLOAK_CLIENT_ID = import.meta.env?.VITE_KEYCLOAK_CLIENT_ID ?? 'customer-portal-frontend';

// Multi-tenant subdomain SSO — the portal's base domain. A company subdomain is any single label
// to the left of this (e.g. `acme` in `acme.benchmarkit.solutions`). Empty/localhost => main domain.
export const BASE_DOMAIN = import.meta.env?.VITE_BASE_DOMAIN ?? '';

// The main (non-tenant) portal host — where generic login + the company picker live. Defaults to
// `portal.<BASE_DOMAIN>` (the reserved main-domain prefix); override with VITE_PORTAL_HOST if prod
// uses a different host. Empty when there is no base domain (pure-localhost dev).
export const PORTAL_HOST = import.meta.env?.VITE_PORTAL_HOST ?? (BASE_DOMAIN ? `portal.${BASE_DOMAIN}` : '');

// Idle auto-logout. A signed-in user with no mouse, keyboard, scroll or touch activity for
// IDLE_TIMEOUT_MINUTES is signed out; a warning with a countdown opens IDLE_WARNING_SECONDS before.
// Keycloak's SSO Session Idle is the server-side backstop and must be set slightly above this
// (e.g. 16 minutes for 15).
export const IDLE_TIMEOUT_MINUTES = 15;
export const IDLE_WARNING_SECONDS = 60;
